module.exports = __webpack_public_path__ + "static/media/hardy-app-demo-tracker.5a8628dd.mp4";